<template>
  <div>
    <div style="display: inline">
      <badge :type="getDeliveryBadgeType()">
        {{ $t(`PROPERTIES.PROPERTIES_STATUS_${property.status}`) }}
      </badge>
    </div>
  </div>
</template>

<script>
import {
  STATUS_ACTIVE,
  STATUS_CANCEL,
  STATUS_PENDING,
  STATUS_APPROVED,
  STATUS_CONFIRMED,
} from "@/constants/properties";

export default {
  name: "property-status-badge-component",

  components: {},

  mixins: [],

  props: ["property"],

  data() {
    return {};
  },

  computed: {},

  methods: {
    getDeliveryBadgeType() {
      switch (this.property.status) {
        case STATUS_ACTIVE:
          return "success";
        case STATUS_PENDING:
          return "primary";
        case STATUS_APPROVED:
          return "warning";
        case STATUS_CANCEL:
          return "danger";
        case STATUS_CONFIRMED:
          return "yellow";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
